import { ImportsModule } from './imports';
import { Component } from '@angular/core';
import { routes } from './app.routes';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from './services/user.service';
import { CustomerService } from './services/customer.service';
import { MessagingService } from './services/messaging.service';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [ImportsModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  hideMenu = true;
  routes: any[] = routes;
  activeItem: MenuItem | undefined;
  customer: any = null;
  apiKey: any = null;
  customerName: any = null;

  constructor(private router: Router, private userService: UserService, private customerService: CustomerService, private messagingService: MessagingService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // status-report is special... 
        if (event.url.match(/^\/status-report/i)) {
          const customer = event.url.match(/customer=([^&]+)/);
          const apiKey = event.url.match(/apiKey=([^&]+)/);
          if (customer && customer[1] && apiKey && apiKey[1]) {
            userService.authenticate(customer[1], apiKey[1], "");
          }
          return;
        }
        this.hideMenu = event.url === "/";
        if (this.hideMenu) this.customerName = null;
        userService.ensureAuthentication();

        if (userService.isAuthenticated() && !this.hideMenu && !this.customerName) {
          const routePathRegExp = new RegExp(event.url.substring(1), "i");
          const thisRoute = this.routes.find(i => routePathRegExp.exec(i.path));
          if (thisRoute) this.activeItem = thisRoute;
          customerService.getCustomer().subscribe({
            next: (data: any) => {
              this.customerName = data.description;
            },
            error: (error: any) => {
              this.messagingService.showHttpError("error", error.error, "Failed to load data.", error);
            }
          });
        }
      }
    });
  }
}
